var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-info-wrapper"},[_c('div',{staticClass:"info-item",class:{[_vm.gameInfo.kind]: true}},[_c('span',[_vm._v(_vm._s(_vm.gameInfo.kind))])]),_c('div',{staticClass:"info-item"},[_c('span',[_vm._v(_vm._s(_vm.gameInfo.player))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }